import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
    state: {
        user: {
            username: '',
            token: ''
        }
    },
    mutations: {
        login(state, { username, token }) {
            state.user.username = username;
            state.user.token = token;
        },
        logout(state) {
            state.user.username = '';
            state.user.token = '';
        }
    },
    actions: {
        async login({ commit }, { username, password }) {
            const response = await axios.post('/signin', {
                'username':username,
                'password': password,
                'op': 'login'
            });
            // console.log(response);
            const token = response.data.token;
            commit('login', { username, token });
        },
        logout({ commit }) {
            commit('logout');
        }
    },
    getters: {
        isLogined: state =>  !!state.user.token,
        username: state => state.user.username,
        token: state => state.user.token,
    }
});